var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormCardItem',{attrs:{"title":"Configurações"},scopedSlots:_vm._u([{key:"title",fn:function(props){return [_c('CCardHeader',{staticClass:"d-flex justify-content-between align-items-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(props.title))])])]}}])},[[_c('CCol',{attrs:{"col":"12"}},[_c('VerticalTabs',{attrs:{"tabs":_vm.tabs}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }